import { render, staticRenderFns } from "./IconLabel.vue?vue&type=template&id=2da1e4d3"
import script from "./IconLabel.vue?vue&type=script&lang=js"
export * from "./IconLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports